import { render, staticRenderFns } from "./onedetail.vue?vue&type=template&id=072c1a62&"
import script from "./onedetail.vue?vue&type=script&lang=js&"
export * from "./onedetail.vue?vue&type=script&lang=js&"
import style0 from "./onedetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports